import { ContentBlock, ExpertHelp, GuideTypes, Metadata } from "../models";
import { Entry } from "contentful";
import {
  convertToHtmlString,
  convertToPlainTextString,
  findContent,
  parseIntoImage,
} from "../utils";
import { FieldMapping, UserContextValues } from "../types";
import { ButtonVariant } from "@trailhead/asurion-ui";

export const createExpertHelp = (
  fieldMapping: FieldMapping<ExpertHelp>,
  entries: Entry<ContentBlock & Metadata>[],
  guideType: GuideTypes,
  userContextValues?: UserContextValues,
): ExpertHelp => {
  const buttonText = findContent(entries, fieldMapping.buttonText, guideType);
  const title = findContent(entries, fieldMapping.title, guideType);
  const subtext = findContent(entries, fieldMapping.subtext, guideType);
  const secondaryButtonText = findContent(
    entries,
    fieldMapping.secondaryButtonText,
    guideType,
  );
  const icon = findContent(
    entries,
    fieldMapping.icon,
    guideType,
  );

  const supportNumber = findContent(
    entries,
    fieldMapping.supportNumber,
    guideType,
  );

  return {
    buttonText: convertToHtmlString(
      buttonText?.fields.richContent,
      userContextValues,
    ),
    buttonVariant: fieldMapping.buttonVariant as ButtonVariant,
    title: convertToHtmlString(title?.fields.richContent, userContextValues),
    subtext: convertToHtmlString(
      subtext?.fields.richContent,
      userContextValues,
    ),
    secondaryButtonText: convertToHtmlString(
      secondaryButtonText?.fields.richContent,
      userContextValues,
    ),
    secondaryButtonVariant:
      fieldMapping.secondaryButtonVariant as ButtonVariant,
    icon: parseIntoImage(
      icon?.fields.richContent.content[0].data
    ),
    supportNumber: convertToPlainTextString(supportNumber?.fields.richContent),
  };
};
